import { getMetadata } from 'firebase/storage';

import { getValueOrFallback } from '../../../utils/index.js';
import type { UserPatientDocument } from '../DocumentManager.types.ts';

type GetDescriptionParams = {
  metadata: Awaited<ReturnType<typeof getMetadata>>;
  fileName: string;
  userDocuments?: UserPatientDocument[];
};

export const getDescription = ({ metadata, fileName, userDocuments }: GetDescriptionParams) =>
  metadata?.customMetadata?.description ??
  getValueOrFallback(userDocuments?.find((item) => item.fileName === fileName)?.description, '');
